import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';

import { BaseApiEndpointService } from './base-api-endpoint.service';
import { ProductsEndpoints } from './models/poducts-endpoint.model';

@Injectable({ providedIn: 'root' })
export class ProductsApiEndpointService extends BaseApiEndpointService {
  constructor(store: Store) {
    super(store, 'products');
  }

  getCountriesConfigUrl(brand: string): string {
    return this.constructUrl(ProductsEndpoints.CountriesConfig(brand));
  }

  getBaseQuoteConfigUrl(brand: string): string {
    return this.constructUrl(ProductsEndpoints.QuoteConfig(brand));
  }

  getBrandConfigUrl(brand: string): string {
    return this.constructUrl(ProductsEndpoints.Brand(brand));
  }

  getUnderwriterConfigUrl(brand: string): string {
    return this.constructUrl(ProductsEndpoints.Underwriters(brand));
  }

  getInsuranceFeaturesUrl(brand: string, icId: number): string {
    return this.constructUrl(ProductsEndpoints.Features(brand, icId));
  }

  getTenderTypeUrl(brand: string, icId: number): string {
    return this.constructUrl(ProductsEndpoints.TenderTypes(brand, icId));
  }

  getCurrenciesUrl(brand: string): string {
    return this.constructUrl(ProductsEndpoints.Currencies(brand));
  }

  getPlanSummaryUrl(brand: string, planId: number): string {
    return this.constructUrl(ProductsEndpoints.PlanSummary(brand, planId));
  }

  getPlanBenefitsUrl(brand: string, planId: number): string {
    return this.constructUrl(ProductsEndpoints.PlanBenefits(brand, planId));
  }

  getPlanOptionsUrl(brand: string, planId: number): string {
    return this.constructUrl(ProductsEndpoints.PlanOptions(brand, planId));
  }

  getDonationConfigUrl(brand: string): string {
    return this.constructUrl(ProductsEndpoints.DonationConfig(brand));
  }
}
